import React from 'react'
//import { connect } from 'react-redux'

import { SETTINGS_PAGINATION } from 'utils/consts'
//import actions from 'store/actions'

import searchIcon from 'assets/images/search.svg'

export default class Search extends React.Component {
  /**
   * @param {Object} e
   */
  handleInput = async e => {
    if (this.props.isLocalSearch) {
      this.props.onChangeSearch(e.target.value)
    } else {
      const data = {
        count: this.props.itemsPerPage,
        page: SETTINGS_PAGINATION.PAGE_NUMBER,
        title: e.target.value,
      }
  
      try {
        await this.props.fetchItems(data)
        this.props.onChangeSearch(data.title)
      } catch (error) {
        console.log(error)
      }
    }
  }

  render() {
    const { children } = this.props

    return (
      <>
        <div className='wrapper-search-input'>
          <img src={searchIcon} alt='' />
          <input
            className='input'
            type='input'
            onInput={this.handleInput}
            placeholder='Поиск'
          />
        </div>
        {children}
      </>
    )
  }
}
/* 
const mapDispatchToProps = dispatch => {
  return {
    fetchUsers: data => dispatch(actions.users.fetchUsers(data)),
  }
}

export default connect(null, mapDispatchToProps)(Search) */
